// PDP Variant Slider
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    if (!window.currentProduct) return;
    
    const product = window.currentProduct;
    const galleryMain = document.querySelector('.gallery-main')?.swiper;
    const galleryThumbs = document.querySelector('.gallery-thumbs')?.swiper;
    const mobileSlider = document.querySelector('.product-card-slider-mobile')?.swiper;
    const variantInput = document.querySelector('input[name="id"]');
    const form = document.getElementById('AddToCartForm');
    
    function updateSlider(variantId) {
      const variant = product.variants.find(v => v.id === parseInt(variantId));
      if (!variant?.featured_media) return;
      
      const idx = product.media.findIndex(m => m.id === variant.featured_media.id);
      if (idx === -1) return;
      
      galleryMain?.slideTo(idx);
      galleryThumbs?.slideTo(idx);
      mobileSlider?.slideTo(idx);
    }

    if (variantInput) {
      new MutationObserver(() => updateSlider(variantInput.value))
        .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      
      variantInput.addEventListener('change', () => updateSlider(variantInput.value));
    }

    form?.addEventListener('change', () => {
      setTimeout(() => variantInput && updateSlider(variantInput.value), 50);
    });

    document.addEventListener('variant:changed', e => {
      e.detail?.variant && updateSlider(e.detail.variant.id);
    });
    
  }, 500);
});